import { IGoal } from "motw_core/Entity/IGoal";
import * as React from "react";
import Render from "source/app/presentation/Shared/Render";

export function ShowDailyGoalIcon({ matchingGoal }: { matchingGoal: IGoal; }) {
    return (
        <Render
            id={`calendar_dailygoalicon`}
            when={matchingGoal.isdaily}
            tooltip="daily goal"
        >
            <span
                style={{
                    padding: "4px",
                    borderRadius: "4px",
                    margin: "10px",
                    fontSize: "11px",
                    background: "#1e1e1e85",
                    fontWeight: "bold",
                    opacity: 0.5,
                }}
            >
                DG
            </span>
        </Render>
    );
}
